var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "collapse_arrow_svg__a",
    d: "M7 4h8l-8 8z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-135 6.843 5.036)",
    xlinkHref: "#collapse_arrow_svg__a"
  })));
}
export default SvgCollapseArrow;